"use client";
import type React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastProvider } from "@treebo-noss/superhero-design-system";
import { useConfig } from "@/context/ConfigContext";
import { TenantProvider } from "@/context/TenantContext";
import { ApolloWrapper } from "@/lib/apollo/provider";

export default function LoginLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { config } = useConfig();

  return (
    <GoogleOAuthProvider clientId={config?.googleClientId ?? ""}>
      <ApolloWrapper>
        <TenantProvider>
          <ToastProvider>
            <div className="max-w-2xl mx-auto min-h-screen bg-white">
              {children}
            </div>
          </ToastProvider>
        </TenantProvider>
      </ApolloWrapper>
    </GoogleOAuthProvider>
  );
}
